module.exports = __webpack_public_path__ + "static/media/icon-event-email.48de87b5.svg";